export default __webpack_public_path__ + "static/media/game_2_2.df6cdf08.png";